/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Aug 21 2024
 **/

import { Avatar, Button, Column, Divider, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import * as S from "../private/emotion";

export default function DeletedSpaceNoticePopup({
	spaceInfo,
	onClose
}: {
	spaceInfo: PushServices.Space.SpaceDeleted.Data["spaceInfo"];
	onClose: () => void;
}) {
	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		onClose();
	};

	return (
		<S.NoticeWrapper gap={12}>
			<Row css={{ position: "absolute", right: "20px", top: "8px" }}>
				<Button.Icon name="Close24" filled="transparent" variant="contained" size="medium" onClick={onClose} />
			</Row>
			<Row gap={16}>
				<Avatar
					kind="space_80"
					type="image"
					text={spaceInfo.name ?? ""}
					textColor="deco1_50_100"
					src={spaceInfo.thumbnailPath}
					css={{
						flex: "none"
					}}
				/>
				<Column gap={8}>
					<Typography typoSize="Head6">{_T("스페이스 삭제 안내")}</Typography>
					<Column>
						<Typography.p typoSize="Body3_MD">
							{_T(
								"관리자에 의해 스페이스가 자동 삭제되어, {{name}} 이용이 불가합니다. 확인을 누르시면 퇴장 및 스페이스 리스트에서 삭제됩니다.",
								{
									name: spaceInfo.name
								}
							)}
						</Typography.p>
					</Column>
				</Column>
			</Row>
			<Divider type="line" />
			<Row style={{ width: "100%" }} horizonAlign="right">
				<Button filled="primary" onClick={handleClick}>
					{_T("확인")}
				</Button>
			</Row>
		</S.NoticeWrapper>
	);
}
